import api from '../api/request';

if (document.querySelector('#error_page') != null) {
    const counter = document.querySelector('.js-main-count-rooms');
    api.flat_count({ type: 0, page_size: 1 })
        .then(data => {
            counter.innerText = data.count;
        });
}
